import { switchAnatomy } from '@chakra-ui/anatomy';
import {
  StyleFunctionProps,
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

export const trackStyle = defineStyle(
  ({ colorScheme }: Partial<StyleFunctionProps>) => {
    return {
      bg: `${colorScheme}.Container/Neutral/Medium 1`,
      _focusVisible: {
        ring: 4,
        ringColor: `${colorScheme}.Border/Brand/Focus ring/Default`,
      },
      _disabled: {
        bg: `${colorScheme}.Container/Neutral/Disabled/Default`,
        opacity: 1,
      },
      _checked: {
        bg: `${colorScheme}.Container/Brand/Medium 3`,
        _disabled: {
          bg: `${colorScheme}.Container/Brand/Disabled/Default`,
        },
      },
    };
  }
);

export const thumbStyle = defineStyle(
  ({ colorScheme, isDisabled }: Partial<StyleFunctionProps>) => {
    const thumbBgColor = isDisabled
      ? `${colorScheme}.Container/Neutral/Mute 2`
      : `${colorScheme}.Container/Neutral/Static/White`;
    const thumbBgColorChecked = isDisabled
      ? `${colorScheme}.Container/Neutral/Disabled/Default`
      : `${colorScheme}.Container/Neutral/Static/White`;
    return {
      bg: thumbBgColor,
      boxShadow: `Elevation/1`,
      _dark: {
        bg: `${colorScheme}.Container/Neutral/Static/White`,
      },
      _checked: {
        bg: thumbBgColorChecked,
      },
    };
  }
);

const baseStyle = definePartsStyle((props) => {
  return {
    thumb: thumbStyle(props),
    track: trackStyle(props),
  };
});

export const SwitchTheme = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    lg: definePartsStyle({
      container: {
        '--switch-track-width':
          'calc(var(--chakra-sizes-40) - var(--chakra-sizes-18))',
      },
      thumb: {
        width: '18',
        height: '18',
      },
      track: {
        width: 'calc(var(--chakra-sizes-40) - var(--chakra-space-6))',
        height: 'calc(var(--chakra-sizes-24) - var(--chakra-space-6))',
        padding: 'calc(var(--chakra-sizes-6)/2)',
      },
    }),
    sm: definePartsStyle({
      container: {
        '--switch-track-width':
          'calc(var(--chakra-sizes-32) - var(--chakra-space-4))',
      },
      thumb: {
        width: '12',
        height: '12',
        position: 'relative',
      },
      track: {
        width: 'calc(var(--chakra-sizes-32) - var(--chakra-space-4))',
        height: 'calc(var(--chakra-sizes-16) - var(--chakra-space-4))',
        padding: 'calc(var(--chakra-sizes-4)/2)',
      },
    }),
  },
});
